import Shop from '@/shop';
import renderRecaptchaWidgetOnVisible from '@/google-recaptcha/renderRecaptchaWidgetOnVisible';
import renderYandexCaptchaWidgetOnVisible from '@/yandex-captcha/renderCaptchaWidgetOnVisible';
import getCaptchaMessageData from '@/helpers/getCaptchaMessageData';
import resetCaptcha from '@/helpers/resetCaptcha';
import _Singleton from '@/tools/singleton';
import jquery from 'jquery';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import _size from 'lodash/size';
import ajaxShop from '@/ajax/shop/';

import options from '@/ui/ui_comments/default-selectors.json';
import settings from '@/ui/ui_comments/default-settings.json';

import { CAPTCHA_TYPE_GOOGLE, CAPTCHA_TYPE_YANDEX } from '@/constants';

/**
 * @class
 * @private
 *
 * @description
 * DOM + Comments
 */
const CommentsDOM = function() {
  const self = this;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
  });
};

/**
 * Инициализация
 * @method
 * @private
 *
 * @returns {void}
 */
CommentsDOM.prototype._init = function() {
  const self = this;

  self.options = options;
  self.settings = settings;
  self.locale = Shop.config.config.locale;
  self.captchaType = Shop.config.config.captcha_type;

  self._bindSendCommentsForm();
  self._bindCommentsFormFieldActions();
  self._checkRequiredFields();
  self._bindShowCommentsModalForm();

  if (self.captchaType === CAPTCHA_TYPE_YANDEX) {
    self._bindYandexCaptchaActions();

    document.querySelectorAll(self.options.formYandexCaptcha.attr).forEach(captchaBlock => {
      renderYandexCaptchaWidgetOnVisible({
        context: self,
        captchaBlock,
        formType: 'comment'
      });
    });
  }

  if (self.captchaType === CAPTCHA_TYPE_GOOGLE) {
    self._bindRecaptchaActions();

    document.querySelectorAll(self.options.formRecaptcha.attr).forEach(recaptchaBlock => {
      renderRecaptchaWidgetOnVisible(self, recaptchaBlock, 'comment');
    });
  }
};

/**
 * Обработчик отправки формы
 * @method
 * @private
 *
 * @returns {void}
 */
CommentsDOM.prototype._bindSendCommentsForm = function() {
  const self = this;

  jquery(document).on('submit', self.options.form.attr, function(event) {
    event.preventDefault();
    self._sendCommentsForm(jquery(this));
  });
};

/**
 * Отправка формы
 * @method
 * @private
 * @param {Object} form - форма
 * @returns {void}
 */
CommentsDOM.prototype._sendCommentsForm = function(form) {
  const self = this;
  const $form = jquery(form);
  const formOptions = $form.data(self.options.form.data);

  // Получаем данные и статус капчи
  const captchaResult = getCaptchaMessageData({
    captchaType: self.captchaType,
    form: $form.get(0),
    fieldRecaptcha: $form.find(self.options.formRecaptcha.attr).get(0),
    fieldYandexCaptcha: $form.find(self.options.formYandexCaptcha.attr).get(0),
    formType: 'comment',
    callback: self._sendCommentsForm.bind(self)
  });

  if (captchaResult.status === 'pending') {
    return;
  }

  try {
    const formData = new FormData($form.get(0));
    const action = $form.attr('action');
    const url = formOptions.url || action.replace('/comments#comment_form', '');
    const successBlock = $form.find(self.options.formSuccess.attr);

    const comment = {
      author: formData.get('comment[author]'),
      email: formData.get('comment[email]'),
      content: formData.get('comment[content]'),
      ...captchaResult.messageData
    };

    ajaxShop.article.sendComment(comment, url)
      .done(function() {
        $form.get(0).reset();

        if (successBlock.length) {
          successBlock.addClass(self.settings.classes.successShow);
          const successOptions = successBlock.data(self.options.formSuccess.data);
          let showTime = self.settings.successShowTime;
          let message = self._getMessageByLocale('successMessage');

          if (successOptions.showTime) {
            showTime = successOptions.showTime;
          }
          if (successOptions.message) {
            message = successOptions.message;
          }

          successBlock.html(message);

          setTimeout(function() {
            successBlock.removeClass(self.settings.classes.successShow);
            successBlock.html('');
            if (successOptions.reloadPage) {
              window.location.href = '#comment_form';
              window.location.reload();
            }
          }, showTime);
        }

        const eventData = { form: $form };
        window.EventBus.publish('send-comment:insales:ui_comments', eventData);
      })
      .fail(function(response) {
        window.EventBus.publish('error-comments:insales:ui_comments', response);

        if (_size(response.errors)) {
          const errorHandles = _keys(response.errors);
          _forEach(errorHandles, function(item) {
            if (item === 'captcha_solution') {
              const $field = $form.find(self.options.formRecaptcha.attr);
              if ($field.length) {
                const fieldRecaptchaErrorMessage =
                  $field.data(self.options.formRecaptcha.data).errorMessage || response.errors[item];
                if (fieldRecaptchaErrorMessage) {
                  self._addFieldError($field, fieldRecaptchaErrorMessage);
                }
              }
            } else {
              const $field = $form.find(`[name="comment[${item}]"]`);
              if ($field.length) {
                const fieldErrorMessage =
                  $field.data(self.options.formField.data).errorMessage || response.errors[item];
                if (fieldErrorMessage) {
                  self._addFieldError($field, fieldErrorMessage);
                }
              }
            }
          });
        }

        console.error('onFail: ', response);
      })
      .always(function() {
        resetCaptcha({
          captchaType: self.captchaType,
          yandexCaptchaBlockSelector: self.options.formYandexCaptcha.attr,
          googleRecaptchaBlockSelector: self.options.formRecaptcha.attr,
          formType: 'comment'
        });
      });
  } catch (errorMessage) {
    return console.error(errorMessage);
  }
};

/**
 * Обработчик событий focus для полей формы
 * @method
 * @private
 *
 * @returns {void}
 */
CommentsDOM.prototype._bindCommentsFormFieldActions = function() {
  const self = this;

  jquery(document).on(
    'focus',
    `${self.options.form.attr} ${self.options.formField.attr}`,
    function() {
      self._removeFieldError(jquery(this));
    }
  );
};

/**
 * Обработчик для поля ReCaptcha.
 * Проверяет ответ рекапчи и добавляет или удаляет ошибку валидации.
 * @method
 * @private
 *
 * @returns {void}
 */
CommentsDOM.prototype._bindRecaptchaActions = function() {
  const self = this;

  window.EventBus.subscribe('google-recaptcha:insales:response', function({ container: googleRecaptchaField }) {
    if (!googleRecaptchaField || !googleRecaptchaField.hasAttribute(self.options.formRecaptcha.data)) {
      return;
    }

    const tokenField =
      googleRecaptchaField.querySelector('[name="g-recaptcha-response"]') ||
      googleRecaptchaField.querySelector('[name="comment[g-recaptcha-response]"]');

    if (tokenField && tokenField.value) {
      self._removeFieldError(jquery(googleRecaptchaField));

      return;
    }

    const fieldOptions = JSON.parse(googleRecaptchaField.dataset[self.options.formRecaptcha.data]);

    let googleRecaptchaFieldError = fieldOptions.errorMessage || '';
    self._addFieldError(jquery(googleRecaptchaField), googleRecaptchaFieldError);
  });
};

/**
 * Обработчик для поля Yandex Captcha.
 * Проверяет ответ капчи и добавляет или удаляет ошибку валидации.
 * @method
 * @private
 * @param {Object} options - параметры для инициализации
 * @param {Object} options.container - контейнер для Yandex Captcha
 * @returns {void}
 */
CommentsDOM.prototype._bindYandexCaptchaActions = function() {
  const self = this;

  window.EventBus.subscribe('yandex-captcha:insales:response', function({ container: yandexCaptchaField }) {
    if (!yandexCaptchaField || !yandexCaptchaField.hasAttribute(self.options.formYandexCaptcha.data)) {
      return;
    }

    const tokenField =
      yandexCaptchaField.querySelector('[name="yandex-smart-token"]')
      || yandexCaptchaField.querySelector('[name="comment[yandex-smart-token]"]');

    if (tokenField && tokenField.value) {
      self._removeFieldError(jquery(yandexCaptchaField));

      return;
    }

    const fieldOptions = JSON.parse(yandexCaptchaField.dataset[self.options.formYandexCaptcha.data]);

    let yandexCaptchaFieldError = fieldOptions.errorMessage || '';
    self._addFieldError(jquery(yandexCaptchaField), yandexCaptchaFieldError);
  });
};

/**
 * Обработчик открытия формы в модальном окне
 * @method
 * @private
 *
 * @returns {void}
 */
CommentsDOM.prototype._bindShowCommentsModalForm = function() {
  const self = this;

  jquery(self.options.showModalForm.attr).on('click', function() {
    let modalId = 'default';

    if (jquery(this).data(self.options.showModalForm.data).modal_id) {
      modalId = jquery(this).data(self.options.showModalForm.data).modal_id;
    }

    const eventData = {
      button: jquery(this),
      modal_id: modalId
    };

    window.EventBus.publish('show-modal-comments:insales:ui_comments', eventData);
  });
};

/**
 * Добавление классов для обязательных полей
 * @method
 * @private
 *
 * @returns {void}
 */
CommentsDOM.prototype._checkRequiredFields = function() {
  const self = this;

  jquery(self.options.formField.attr).each(function() {
    const commentsField = jquery(this);

    if (self._isRequiredField(commentsField)) {
      self._addFieldRequired(commentsField);
    }
  });
};

/**
 * Проверка обязательности поля
 * @method
 * @private
 *
 * @param {Object} fieldNode - DOM-элемент поля
 *
 * @returns {boolean} - true если поле обязательное
 */
CommentsDOM.prototype._isRequiredField = function(fieldNode) {
  const self = this;

  const fieldName = fieldNode.attr('name');
  let isRequired = false;

  switch (fieldName) {
    case 'phone':
      isRequired = self.settings.phoneRequired;
      break;
    case 'name':
      isRequired = self.settings.nameRequired;
      break;
    case 'subject':
      isRequired = self.settings.subjectRequired;
      break;
    case 'content':
    case 'from':
      return true;
  }

  const fieldData = fieldNode.data(self.options.formField.data);
  if (fieldData && fieldData.isRequired) {
    isRequired = fieldData.isRequired;
  }

  return isRequired;
};

/**
 * Добавление специальных css-классов для поля с ошибкой
 * @method
 * @private
 *
 * @param {Object} fieldNode - DOM-элемент поля
 * @param {string} errorMessage - текст ошибки
 *
 * @returns {void}
 */
CommentsDOM.prototype._addFieldError = function(fieldNode, errorMessage) {
  const self = this;

  const errorBlock = fieldNode.parents(self.options.formFieldArea.attr).find(self.options.formFieldError.attr);

  fieldNode.addClass(self.settings.classes.isError);
  fieldNode.parents(self.options.formFieldArea.attr).addClass(self.settings.classes.isError);

  if (errorBlock && errorMessage) {
    errorBlock.html(errorMessage);
  }
};

/**
 * Удаление специальных css-классов для поля с ошибкой
 * @method
 * @private
 *
 * @param {Object} fieldNode - DOM-элемент поля
 *
 * @returns {void}
 */
CommentsDOM.prototype._removeFieldError = function(fieldNode) {
  const self = this;

  const errorBlock = fieldNode.parents(self.options.formFieldArea.attr).find(self.options.formFieldError.attr);

  fieldNode.removeClass(self.settings.classes.isError);
  fieldNode.parents(self.options.formFieldArea.attr).removeClass(self.settings.classes.isError);

  if (errorBlock) { errorBlock.html(''); }
};

/**
 * Добавление специальных css-классов для обязательного поля
 * @method
 * @private
 *
 * @param {Object} fieldNode - DOM-элемент поля
 *
 * @returns {void}
 */
CommentsDOM.prototype._addFieldRequired = function(fieldNode) {
  const self = this;

  fieldNode.addClass(self.settings.classes.isRequired);
  fieldNode.parents(self.options.formFieldArea.attr).addClass(self.settings.classes.isRequired);
};

/**
 * @private
 *
 * @description
 * Получение текста из словаря базовых настроек
 *
 * @param {string} messageName - название сообщения
 *
 * @returns {string} - текст сообщения
 */
CommentsDOM.prototype._getMessageByLocale = function(messageName) {
  const self = this;

  if (typeof self.locale !== 'undefined') {
    let resultMessage = self.settings[messageName][self.locale];

    if (typeof resultMessage === 'undefined') {
      resultMessage = self.settings[messageName].ru;
    }

    return resultMessage;
  }

  return self.settings[messageName].ru;
};

export default _Singleton(CommentsDOM).getInstance();
